import { DOCUMENT, inject, InjectionToken } from '@angular/core'

const REGEX_PREVIEW_TOKEN = /preview-token=([a-z0-9-]+)/i

export const PREVIEW_TOKEN = new InjectionToken<string | null>('PREVIEW_TOKEN', {
  providedIn: 'root',
  factory: () => {
    const hash = inject(DOCUMENT).location.hash
    const match = REGEX_PREVIEW_TOKEN.exec(hash)
    if (match) {
      return match[1]
    }
    return null
  },
})
